import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-400 p-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-lg font-semibold leading-none tracking-tight"
}
const _hoisted_3 = {
  key: 1,
  class: "text-lg font-semibold leading-none tracking-tight"
}

import {ref, watch} from "vue";
  import {useRoute} from "vue-router";
  import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger
  } from '@/components/ui/tabs'
  import BuildingForm from "@/components/building/form/BuildingForm.vue";
  import RoofsForm from "@/components/building/form/RoofsForm.vue";
import useEventsBus from "@/utils/eventBus";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TabsForm',
  setup(__props) {

  const isRoofTabDisabled = ref(true);
  const route = useRoute();
  let id = ref(route.params.id);

  if (id.value !== '0') {
    isRoofTabDisabled.value = false;
  }

  function enableRoofTab(value: any) {
    id.value = value
    isRoofTabDisabled.value = false;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tabs), { "default-value": "buildings" }, {
    default: _withCtx(() => [
      _createVNode(_unref(TabsList), { class: "justify-center flex h-[3rem]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(TabsTrigger), {
            value: "buildings",
            class: "w-full h-full text-md font-semibold"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('building.building')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(TabsTrigger), {
            disabled: isRoofTabDisabled.value,
            value: "roofs",
            class: "w-full h-full text-md font-semibold"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('building.roofs')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_unref(id) === '0')
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$t('table.add')), 1))
          : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t('table.edit')), 1))
      ]),
      _createVNode(_unref(TabsContent), { value: "buildings" }, {
        default: _withCtx(() => [
          _createVNode(BuildingForm, {
            entity: "buildings",
            id: _unref(id),
            onEnableRoofs: enableRoofTab
          }, null, 8, ["id"])
        ]),
        _: 1
      }),
      _createVNode(_unref(TabsContent), { value: "roofs" }, {
        default: _withCtx(() => [
          _createVNode(RoofsForm, {
            entity: "coverages",
            id: _unref(id)
          }, null, 8, ["id"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})